import ToastProvider from '@components/Toast/ToastProvider';
import { CssBaseline, ThemeProvider, useMediaQuery } from '@mui/material';
import getDarkTheme from 'constants/Theme/DarkTheme';
import getLightTheme from 'constants/Theme/LightTheme';
import { RequireAuth } from 'hooks/useAuth';
import { AppContainer } from 'pages/containers';
import NavigationDialog from 'pages/Navigation/NavigationDialog';
import React, { FC, useState } from 'react';
import { ProjectProvider } from './ProjectProvider';

const AuthenticatedApp: FC = () => {
	const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
	const [isDarkMode, setTheme] = useState(prefersDarkMode);

	const onThemeChange = React.useCallback(
		(isDarkTheme: boolean) => {
			setTheme(isDarkTheme);
		},
		[setTheme]
	);

	return (
		<ThemeProvider theme={isDarkMode ? getDarkTheme() : getLightTheme()}>
			<RequireAuth>
				<ProjectProvider>
					<>
						<CssBaseline enableColorScheme />
						<NavigationDialog />
						<ToastProvider>
							<AppContainer
								isDarkTheme={isDarkMode}
								onThemeChange={onThemeChange}
							/>
						</ToastProvider>
					</>
				</ProjectProvider>
			</RequireAuth>
		</ThemeProvider>
	);
};

export default AuthenticatedApp;
